// **********************************************************
// Media Assets
// **********************************************************

const mediaSlider = document.querySelectorAll('[data-slider="download-media-slider"]');

const mediaSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  breakpoints: {
    1023: {
      spaceBetween: 0,
    },
  },
};

mediaSlider.forEach((el) => new Swiper(el, mediaSliderOptions));

// **********************************************************
// Download Media Assets
// **********************************************************

const downloadImagesEl = document.querySelector('.download-module__media .download-module__link');

if (downloadImagesEl) {
  // Axios get filtered post list
  const axiosDownloadImages = async (images) => {
    const formDataInput = {
      action: 'downloadImages',
      images,
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      window.location.href = response.data.data.zip_url;
    } catch (err) {
      console.error(err);
    }
  };

  // Click event for download images
  downloadImagesEl.addEventListener('click', (e) => {
    if (downloadImagesEl.getAttribute('href') === '#') {
      e.preventDefault();
      const imageEls = document.querySelectorAll('.download-module__thumbnails img');
      const images = Array.from(imageEls).map((image) => image.dataset.path);

      axiosDownloadImages(images);
    }
  });
}
